
const translaiton = {
    weCouldentFindWhatYouSearched: 'לא מצאנו מה שחיפשת..',
    tryAgain: 'אפשר לנסות מחדש'
}

export default translaiton
